// hierarchy.js — F1 (WAVY_AUDIT.md Future Hardening F1): SEED-ONLY module.
//
// Runtime organizational authority is the OrganizationNode DB + the H1/M5
// services. This file exists ONLY as the offline seed/bootstrap fallback that
// `utils/structureSnapshot.js` merges beneath the DB snapshot when the
// database is unreachable. Consumers must go through useStructureSnapshot —
// importing this module directly as a runtime display source is prohibited
// (guarded by backend/test-f1-static-hierarchy-endstate.js).

const hierarchy = {
  // ===================== KENYA ARMY FULL UNIT STRUCTURE =====================
  "HQ KA": {
    subBranches: {
      "HQ KA": {
        "OPS BRANCH": {
          "OPS SUB BRANCH": [
            "COOPS", "COL OPS", "SO1 OPS", "S01PLANS", "SO2 OPS",
            "GLO", "SO2 W/KEEPER", "S02 OPS & LOGS", "SO2 PLANS", "MASTER CHIEF"
          ],
          "INT SUB BRANCH": ["SO1 INT", "SO2 INT"],
          "CIS SUB BRANCH": [
            "COL CIS", "SO1 IT", "SO1 COMMS", "SO2 COMMS", "SO2 IT",
            "SO2 CYBER", "CHIEF CLERK", "CLERK", "YOS", "FOS"
          ],
          "SYS SUB BRANCH": [
            "COOPS", "COL SYS", "SO1 SYS", "SO2 EQPT/VEH SYS",
            "SO2 AMMO/WPN SYS", "S02 SYS", "CLERK"
          ],
          "OOTW SUB BRANCH": [
            "COL OOTW", "SO1 OOTW", "S02 OOTW", "S02 PSO/COE",
            "SO2 ENVIROMENTAL", "SO2 CBT ENGR/CIMIC"
          ],
        },
        "LOGS BRANCH": {
          "SUPPLY SUB BRANCH": ["SUPPLY OFFICER"],
          "TRANSPORT SUB BRANCH": ["TRANSPORT OFFICER"],
          "MAINTENANCE SUB BRANCH": ["MAINTENANCE OFFICER"],
          "PROCUREMENT SUB BRANCH": ["PROCUREMENT OFFICER"],
        },
        "PERS BRANCH": {
          "HR SUB BRANCH": ["HR MANAGER"],
          "DISCIPLINE SUB BRANCH": ["DISCIPLINE OFFICER"],
          "RECORDS SUB BRANCH": ["RECORDS OFFICER"],
        },
        "TRG BRANCH": {
          "DOCTRINE SUB BRANCH": ["DOCTRINE DEV OFFICER"],
          "COURSE SUB BRANCH": ["TRAINING COORDINATOR"],
        },
        "MED BRANCH": {
          "FIELD MEDICINE SUB BRANCH": ["FIELD DOCTOR"],
          "HEALTH SERVICES SUB BRANCH": ["MEDICAL OFFICER"],
        },
      },
      DHQ: {
        SYSTEMS: {
          "SYSTEMS HQ": ["Chief of Systems", "CLERK"],
          "LAND PROGRAMMES": ["COL Land Programmes", "SO1", "SO2"],
          "AIR PROGRAMMES": ["COL Air Programmes", "SO1", "SO2"],
          "SEA PROGRAMMES": ["COL Sea Programmes", "SO1", "SO2"],
          "CIS PROGRAMMES": ["COL CIS Programmes", "SO1", "SO2"],
        },
        CIS: {
          "CIS HQ": ["Chief of CIS", "CLERK"],
          COMMUNICATIONS: ["COL Communications", "SO1 Communications", "SO2 EW"],
          "CIS INFRASTRUCTURE": [
            "COL CIS Infrastructure",
            "SO1 Infrastructure",
            "SO2 Networks",
            "SO2 Backbone",
          ],
          "INFORMATION SYSTEMS": [
            "COL Information Systems",
            "SO1 IT",
            "SO1 Cyber",
            "SO2 Systems Administration",
          ],
        },
        MPCHQ: {
          MPCHQ: [
            "CORPS COMMANDER",
            "DEPUTY CORPS COMMANDER",
            "SO1 OPS & TRG",
            "SO1 LEGAL",
            "SO2 PERS & LOGS",
            "SO2 OPS & TRG",
            "SO2 INT & SEC",
            "SO2 LEGAL",
            "MASTER CHIEF",
            "CHIEF CLERK",
            "CLERK",
            "SEC TO CORPS COMMANDER",
          ],
          "1 MP BN": [],
          "2 MP BN": [],
          "MPC SIU": ["CO", "ADJUTANT", "HOD", "2IC", "DORCUS CLERK", "MASTER CHIEF"],
          PPU: [],
          SOMP: [],
        },
      },
    },
  },
  "2 BDE": {
    subBranches: {
      "2 BDE HQ": ["BDE COMD", "BDE 2IC", "BDE OPSO", "BDE Adjutant", "Chief Clerk"],
      "3 KR": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "5 KR": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "9 KR": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "21 TPT COY": ["OC", "Admin Officer", "Chief Clerk", "Clerk"],
      "22 FLD WKSP": ["OC", "Admin Officer", "Chief Clerk", "Clerk"],
      "23 OCC": ["OC", "Admin Officer", "Chief Clerk", "Clerk"],
    },
  },
  "4 BDE": {
    subBranches: {
      "4 BDE HQ": ["BDE COMD", "BDE 2IC", "BDE OPSO", "BDE Adjutant", "Chief Clerk"],
      "1 KR": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "7 KR": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "15 KR": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "41 TPT COY": ["OC", "Admin Officer", "Chief Clerk", "Clerk"],
      "42 FLD WKSP": ["OC", "Admin Officer", "Chief Clerk", "Clerk"],
      "43 OCC": ["OC", "Admin Officer", "Chief Clerk", "Clerk"],
    },
  },
  "6 BDE": {
    subBranches: {
      "6 BDE HQ": ["BDE COMD", "BDE 2IC", "BDE OPSO", "BDE Adjutant", "Chief Clerk"],
      "17 KR": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "19 KR": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "21 KR": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "61 TPT COY": ["OC", "Admin Officer", "Chief Clerk", "Clerk"],
      "62 FLD WKSP": ["OC", "Admin Officer", "Chief Clerk", "Clerk"],
      "63 OCC": ["OC", "Admin Officer", "Chief Clerk", "Clerk"],
    },
  },
  "8 BDE": {
    subBranches: {
      "8 BDE HQ": ["BDE COMD", "BDE 2IC", "BDE OPSO", "BDE Adjutant", "Chief Clerk"],
      "23 MIB": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "25 MIB": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "27 MIB": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
    },
  },
  "110 MIB": {
    subBranches: {
      "110 MIB HQ": ["BDE COMD", "BDE 2IC", "BDE OPSO", "BDE Adjutant", "Chief Clerk"],
      "31 MIB": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "33 MIB": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "35 MIB": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
    },
  },
  "ARMD": {
    subBranches: {
      "ARMD BDE HQ": ["BDE COMD", "BDE 2IC", "BDE OPSO", "BDE Adjutant", "Chief Clerk"],
      "76 ARB": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "78 TK BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "81 TK BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "86 ARB": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
    },
  },
  "ARTY": {
    subBranches: {
      "ARTY BDE HQ": ["BDE COMD", "BDE 2IC", "BDE OPSO", "BDE Adjutant", "Chief Clerk"],
      "75 ARTY BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "66 ARTY BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "77 ARTY BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "55 ARTY BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "88 ARTY BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
    },
  },
  "COMBAT ENGRS": {
    subBranches: {
      "CBT ENGRS BDE HQ": ["BDE COMD", "BDE 2IC", "BDE OPSO", "BDE Adjutant", "Chief Clerk"],
      "10 ENGRS BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "12 ENGRS BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "14 ENGRS BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
    },
  },

  // ===================== HQ ASOB =====================
  "HQ ASOB": {
    subBranches: {
      "MAIN HQ": [
        "COMD ASOB",
        "Deputy COMD",
        "SO2 Ops & Trg",
        "SO3 Ops & Trg",
        "SO2 Pers & Log",
        "SO3 Pers & Log",
        "SO2 Cbt Int",
        "MCC",
        "Clerk",
      ],
      "HQ 20 Para BN": ["CO 20", "BN 2IC", "OPSO", "Adjutant", "Clerk"],
      "HQ 60 ASB": ["CO 60", "BN 2IC", "OPSO", "Adjutant", "Clerk"],
      "HQ 40 Ranger": ["CO 40", "BN 2IC", "OPSO", "Adjutant", "Clerk"],
      "HQ SQTS": ["Admin Officer", "Adjutant", "Clerk"],
      CAU: ["OC", "BSO", "Clerk"],
    },
  },

  "CONSTR ENGRS": {
    subBranches: {
      "18 ENGRS BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "CONSTR ENGRS HQ": ["Commander", "Deputy Commander", "SO1", "SO2", "Chief Clerk", "Clerk"],
    },
  },
  "EMB GAR HQS": {
    subBranches: {
      "EMB GAR HQ": ["Commander", "Deputy Commander", "SO1", "SO2", "Chief Clerk", "Clerk"],
      "CBT WING": ["OC", "Admin Officer", "Chief Clerk", "Clerk"],
      "TECH WING": ["OC", "Admin Officer", "Chief Clerk", "Clerk"],
      "ADMIN WING": ["OC", "Admin Officer", "Chief Clerk", "Clerk"],
    },
  },
  "KAHAWA GARRISON": {
    subBranches: {
      "KAH GAR HQ": ["Commander", "Deputy Commander", "SO1", "SO2", "Chief Clerk", "Clerk"],
      "AHQ SIG BN": {
        KACS: ["Chief Clerk", "Master Clerk", "SO2", "Commander"],
        SOS: [
          "Clerk",
          "Chief Clerk",
          "Adjutant",
          "Admin Officer",
          "SO Comms",
          "SO IT",
          "SO Tech",
          "Chief Instructor",
          "Commandant",
        ],
        BATTALION: [
          "Concern",
          "Dispatch Clerk",
          "Archive Clerk",
          "Chief Clerk",
          "Adjutant",
          "BN 2IC",
          "CO",
        ],
        "IT SQDRN": ["Clerk", "OC"],
        "COMMS SQDRN": ["Clerk", "OC"],
      },
      "KACT HQ": ["Commander", "Deputy Commander", "SO1", "SO2", "Chief Clerk", "Clerk"],
      "TPT BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "HVY LIFT BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "KACEME HQ": ["Commander", "Deputy Commander", "SO1", "SO2", "Chief Clerk", "Clerk"],
      "WKSP BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "2ND ORD BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      KATU: ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
    },
  },
  "LANGATA GARRISON": {
    subBranches: {
      "LANGATA GAR HQ": ["Commander", "Deputy Commander", "SO1", "SO2", "Chief Clerk", "Clerk"],
      KAB: ["CO", "Adjutant", "Chief Clerk", "Clerk"],
    },
  },
  "MARIAKANI GARRISON": {
    subBranches: {
      "MARIAKANI GAR HQ": ["Commander", "Deputy Commander", "SO1", "SO2", "Chief Clerk", "Clerk"],
    },
  },
  "GILGIL GARRISON / WESTCOM": {
    subBranches: {
      "GILGIL GAR HQ": ["Commander", "Deputy Commander", "SO1", "SO2", "Chief Clerk", "Clerk"],
    },
  },
  "MEDICAL CORPS": {
    subBranches: {
      "1 MED BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      "2 MED BN": ["CO", "Adjutant", "Chief Clerk", "Clerk"],
      KAMD: ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
      LRH: ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
      ERH: ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
    },
  },
  "TRAINING INSTITUTIONS": {
    subBranches: {
      KMA: {
        "ACADEMY HQ": [
          "Comdt",
          "Sec to Comdt",
          "CI",
          "Sec to CI",
          "SO1 Co-ord",
          "SO2 Co-ord",
          "SO2 Co-ord Branch",
          "Master Clerk",
          "Chief Clerk",
        ],
        "COORD BRANCH": {
          PRODUCTION: [],
          PROCUREMENT: [],
        },
        "LEGAL DEPT": [],
        "INT DEPT & MP DET": [],
        "OFFICER CADET SCHOOL": {
          "HQ OCS": [
            "OC OCS",
            "2IC OCS",
            "Adjutant",
            "Chief Clerk",
            "Clerk GD",
            "Training Clerk",
            "Typist & Support Staff",
          ],
          "DEMO COMPANY": [
            "OC Demo Coy",
            "2IC Demo Coy",
            "Platoon Commander",
            "Instructor",
            "Clerk GD",
          ],
          "TRAINING & SUPPORT DIVISION": [
            "IC Training & Support",
            "2IC Training & Support",
            "Training Officer",
            "Support Officer",
            "Instructor",
            "Clerk GD",
          ],
          "PT & CBT TRAINING": [
            "IC PT & CBT Training",
            "2IC PT & CBT Training",
            "PT Instructor",
            "Combat Skills Instructor",
            "Combative Instructor",
            "Live Guard Instructor",
            "Instructor",
            "Clerk GD",
          ],
          "TACWPN": [
            "IC TACWPN",
            "Weapons Instructor",
            "Instructor",
            "Clerk GD",
          ],
          "COMMS": [
            "IC COMMS",
            "Communications Instructor",
            "Instructor",
            "Clerk GD",
          ],
          "DRILL": [
            "IC Drill",
            "Drill Instructor",
            "Instructor",
            "Clerk GD",
          ],
          "ADMIN": [
            "IC Admin",
            "Admin Officer",
            "Chief Clerk",
            "Clerk GD",
            "Training Clerk",
            "Typist & Support Staff",
          ],
          "GSO 3RD YEAR": [
            "GSO 3rd Year",
            "Instructor",
          ],
          "GSO 2ND YEAR": [
            "GSO 2nd Year",
            "Instructor",
          ],
          "GSO 1ST YEAR": [
            "GSO 1st Year",
            "Instructor",
          ],
          "GSO GRADUATE": [
            "GSO Graduate",
          ],
          "SPEC/SDO": [
            "Specialist Officer",
            "SDO",
          ],
        },
        "FACULTY OF ACADEMIC STUDIES": {
          "FAS HQ": [
            "DEAN FAS",
            "SO3 GSO",
            "Chief Clerk",
            "Clerk GD",
            "Training Clerk",
            "Typist & Support Staff",
          ],
          "ACADEMICS": [
            "Senior Lecturer",
            "SO3 Academics",
            "Lecturer",
            "Tutorial Fellow",
            "GIS Officer",
            "MET Officer",
            "Biology Lab Technician",
            "SO3 Labs",
            "IC Labs",
            "2IC Labs",
            "Lab Assistant",
            "Lab Technician",
            "Lab Technician Instructor",
            "MET Technician",
            "GIS Technician",
          ],
          "LIB & INFO RESOURCE CENTRE": [
            "Chief Librarian",
            "Assistant Librarian",
            "Education Instructor",
            "IC Exams",
            "Library Assistant",
            "Library Assistant (Archives)",
            "Support Staff",
          ],
          "LIBRARY": [
            "Library Assistant",
            "Assistant Librarian Instructor",
            "Curator",
            "Library Assistant (Skill/Edn Instructor)",
          ],
          "ARCHIVAL": [
            "Archivist",
            "Curator",
          ],
          "ICT": [
            "System Manager",
            "Deputy System Manager",
            "QMS",
          ],
          "COMP TECH": [
            "Computer Technician",
            "Tech Specialist",
            "Computer System Expert",
          ],
          "SYSTEM NETWORK": [
            "IC System Network",
            "Network Admin",
            "Web Designer",
            "Network Specialist",
            "Database Admin",
          ],
          "IT MAINTENANCE": [
            "ICT Officer",
            "ICT Instructor",
            "Tech Lab",
            "Maintenance Technician",
            "ICT Technician",
            "Hardware/Software Technician",
            "Office Maintenance Technician",
          ],
          "AUDIO VISUAL": [
            "AV Technician",
            "Projectionist",
          ],
        },
        "ADMIN WING": {
          "MOTOR TPT": [],
          SIGNAL: [],
          ACCOUNTS: [],
          "CBT STORES": [],
          MEDICAL: [],
          CHAPLAINCY: [],
        },
        RSCD: {
          RSP: [],
          "STDs DEPT": [],
          EXAMS: [],
          "CD DEPT": [],
        },
      },
      SOI: ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
      SOTS: ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
      SOARMR: ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
      SOARTY: ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
      SOME: ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
      SOO: ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
      KAATS: ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
      DFTTS: ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
      DFCTs: ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
      "CAT C": ["Commandant", "Chief Instructor", "Chief Clerk", "Clerk"],
    },
  },

  // ===================== OTHERS =====================
  "Others": ["MA", "DAC", "COMD"]
};

export default hierarchy;
